var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconBoleto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88742 2.09402V32.906H38.8269V2.09402H1.88742ZM1.34816 0C0.60359 0 0 0.669659 0 1.49573V33.5043C0 34.3303 0.60359 35 1.34816 35H39.3661C40.1107 35 40.7143 34.3303 40.7143 33.5043V1.49573C40.7143 0.66966 40.1107 0 39.3661 0H1.34816Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3555 5.08984H35.3407V29.9395H32.3555V5.08984Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5H8V30H5V5Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3398 5.08984H18.325V29.9395H15.3398V5.08984Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4746 5.08984H30.5643V29.9395H28.4746V5.08984Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6992 5.08984H25.4903V29.9395H23.6992V5.08984Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1172 5.08984H21.9083V29.9395H20.1172V5.08984Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.459 5.08984H13.2501V29.9395H11.459V5.08984Z",
    fill: "#D59B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconBoleto);
export default __webpack_public_path__ + "static/media/menu-icon-boleto.9e12375435eae4f312bc3ad827cb4200.svg";
export { ForwardRef as ReactComponent };